import { render, staticRenderFns } from "./PermissionUpdate.vue?vue&type=template&id=18765e12&"
import script from "./PermissionUpdate.vue?vue&type=script&lang=ts&"
export * from "./PermissionUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports